module.exports = __webpack_public_path__ + "img/img-aed2f8.png";